import * as React from "react";
const ShieldCheck = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M18.994 4.861L14.05 2.838a5.458 5.458 0 00-4.098 0L5.006 4.862A2.748 2.748 0 003.25 7.383v3.61a11.104 11.104 0 008.585 10.55.74.74 0 00.33 0 11.105 11.105 0 008.585-10.55v-3.61a2.75 2.75 0 00-1.756-2.522zm.256 6.131A9.575 9.575 0 0112 20.04a9.575 9.575 0 01-7.25-9.047v-3.61a1.256 1.256 0 01.825-1.133l4.943-2.023a3.95 3.95 0 012.962 0l4.946 2.022a1.257 1.257 0 01.824 1.134z" />
      <path d="M14.47 9.53l-3.22 3.22-1.72-1.72a.75.75 0 00-1.06 1.061l2.25 2.25c.139.14.333.22.53.22s.391-.08.53-.22l3.75-3.75a.75.75 0 00-1.06-1.06z" />
    </g>
  </symbol>;
export default ShieldCheck;